import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Paper, Switch, Tab, Tabs } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import Templete from "../../template/Template";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import InputLabel from "../../components/Inputs/InputLabel";
import { AlertConfirm, AlertInfo } from "../../components/Alerts/Alert";
import { permissions } from "../../data/permissoesUsuario";
import { UsuarioType } from "../../types/UsuarioType";
import { api, apiUrl } from "../../services/api";
import SelectSimple from "../../components/Selects/SelectSimple";
import { estadoCivilData, nacionalidadeData } from "../../data/dataCliente";
import { isPermite } from "../../utilities/isPermite";
import DropZoneFile from "../../components/DropZone/DropZoneFile";
import { arrayUf, arrayUfNome } from "../../data/dataUf";

export default function CadastroUsuario() {
    const navigate = useNavigate();
    const [searchParms] = useSearchParams();
    const [openLoad, setOpenLoad] = useState(false);
    const [id_usuario, setIdUsuario] = useState<number | null>(null);
    const [nome_usuario, setNomeUsuario] = useState("");
    const [nome_abreviado_usuario, setNomeAbreviadoUsuario] = useState("");
    const [telefone_usuario, setTelefoneUsuario] = useState("");
    const [cpf_usuario, setCpfUsuario] = useState("");
    const [email_usuario, setEmailUsuario] = useState("");
    const [senha_usuario, setSenhaUsuario] = useState("");
    const [profissao_usuario, setProfissaoUsuario] = useState("");
    const [nacionalidade_usuario, setNacionalidadeUsuario] = useState<string | number>("");
    const [estado_civil_usuario, setEstadoCivilUsuario] = useState<string | number>("");
    const [rg_usuario, setRgUsuario] = useState("");
    const [emissor_rg_usuario, setEmissorRgUsuario] = useState("");
    const [is_advogado, setIsAdvogado] = useState(false);
    const [cod_oab, setCodOAB] = useState("");
    const [sessao_oab_usuario, setSessaoOabUsuario] = useState("");
    const [sessao_oab_usuario_sigla, setSessaoOabSigla] = useState<string | number>("PA");
    const [logo_user, setLogoUser] = useState<string | null>(null);
    const [permissoes, setPermissoes] = useState(permissions);
    const [is_logo_proprio, setIsLogoProprio] = useState(false);
    const [aba, setAba] = useState(0);

    const [banco_advogado_rpv, setBancoAdvRpv] = useState('');
    const [numero_banco_rpv, setNumeroBancoRpv] = useState('');
    const [numero_agencia_rpv, setNumeroAgenciaRpv] = useState('');
    const [numero_conta_rpv, setNumeroContaRpv] = useState('');
    const [chave_pix_usuario, setChavePixUsuario] = useState('');

    async function handleSave() {
        setOpenLoad(true);
        try {
            const permissoes_usuario = permissoes.map(per => {
                const checkList = per.options.filter(p => p.check).map(p => p.value);
                return checkList.toString();
            });
            const data = {
                id_usuario,
                nome_usuario: nome_usuario.toUpperCase(),
                nome_abreviado_usuario: nome_abreviado_usuario.toUpperCase(),
                telefone_usuario, cod_oab, nacionalidade_usuario, sessao_oab_usuario,
                estado_civil_usuario, rg_usuario, emissor_rg_usuario, sessao_oab_usuario_sigla,
                cpf_usuario, email_usuario, senha_usuario, profissao_usuario,
                permissoes_usuario: permissoes_usuario.filter(i => i !== "").toString(),
                is_advogado: Number(is_advogado), is_logo_proprio: Number(is_logo_proprio),
                banco_advogado_rpv, numero_banco_rpv, numero_agencia_rpv, numero_conta_rpv, chave_pix_usuario,
            };
            const channel = id_usuario ? `/updateusuario` : `/createusuario`;
            const response = await api.post(channel, data);
            if (response && response.status === 200 && response.data) {
                if (response.data.error) {
                    console.log(response);
                    AlertInfo({ icon: 'error', title: response.data.message });
                } else if (response.data.success) {
                    AlertInfo({ icon: 'success', title: 'DADOS GRAVADOS' }).then(() => {
                        navigate('/usuarios');
                    });
                }
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setOpenLoad(false);
    }

    function handleDelete() {
        AlertConfirm({ title: "Deletar usuario do sistema?" }).then(async res => {
            if (res.isConfirmed) {
                setOpenLoad(true);
                try {
                    const data = { id_usuario, nome_usuario, email_usuario, usuario_ativo: 0 };
                    const response = await api.post(`/updateusuario`, data);
                    if (response && response.status === 200 && response.data) {
                        if (response.data.error) {
                            AlertInfo({ icon: 'error', title: response.data.message });
                        } else if (response.data.success) {
                            AlertInfo({ icon: 'success', title: 'Usuario removido' }).then(() => {
                                navigate("/usuarios");
                            });
                        }
                    }
                } catch (error) {
                    console.log(error);
                    AlertInfo({ icon: 'error', title: 'Falha na conexão' });
                }
                setOpenLoad(false);
            }
        });
    }

    function handleCheck(idContainer: string, idValue: number) {
        const up = permissoes.map(per => {
            if (per.id === idContainer) {
                const upOption = per.options.map(p => {
                    if (p.value === idValue) return { ...p, check: !p.check };
                    return p;
                });
                return { ...per, options: upOption };
            }

            return per;
        });

        setPermissoes(up);
    }

    const totalPermissoes = permissoes.reduce((acc, per) => acc + per.options.length, 0);
    const totalMarcadas = permissoes.reduce((acc, per) => acc + per.options.filter(p => p.check).length, 0);

    function handleCheckTodas() {
        const marcar = totalMarcadas < totalPermissoes;
        setPermissoes(permissoes.map(per => ({
            ...per,
            options: per.options.map(p => ({ ...p, check: marcar })),
        })));
    }

    function setDataResponse(dataUsuario: UsuarioType) {
        setIdUsuario(dataUsuario.id_usuario);
        setNomeUsuario(dataUsuario.nome_usuario);
        setNomeAbreviadoUsuario(dataUsuario.nome_abreviado_usuario);
        setCpfUsuario(dataUsuario.cpf_usuario);
        setTelefoneUsuario(dataUsuario.telefone_usuario);
        setEmailUsuario(dataUsuario.email_usuario);
        setProfissaoUsuario(dataUsuario.profissao_usuario);
        setIsAdvogado(Boolean(Number(dataUsuario.is_advogado)));
        setCodOAB(dataUsuario.cod_oab);
        setNacionalidadeUsuario(dataUsuario.nacionalidade_usuario);
        setEstadoCivilUsuario(dataUsuario.estado_civil_usuario);
        setRgUsuario(dataUsuario.rg_usuario);
        setEmissorRgUsuario(dataUsuario.emissor_rg_usuario);
        setSessaoOabUsuario(dataUsuario.sessao_oab_usuario);
        setSessaoOabSigla(dataUsuario.sessao_oab_usuario_sigla);
        setIsLogoProprio(Boolean(dataUsuario.is_logo_proprio));

        setBancoAdvRpv(dataUsuario.banco_advogado_rpv);
        setNumeroBancoRpv(dataUsuario.numero_banco_rpv);
        setNumeroAgenciaRpv(dataUsuario.numero_agencia_rpv);
        setNumeroContaRpv(dataUsuario.numero_conta_rpv);
        setChavePixUsuario(dataUsuario.chave_pix_usuario ?? '');

        if (dataUsuario.logo_user) setLogoUser(`${apiUrl}/imguploaded/${dataUsuario.logo_user}`);

        const permiteUsuario = dataUsuario.permissoes_usuario.split(',');
        const upPermission = permissoes.map(per => {
            const up = per.options.map(p => {
                if (permiteUsuario.includes(String(p.value))) return { ...p, check: true };
                return p;
            });
            return { ...per, options: up };
        });
        setPermissoes(upPermission);
    }

    async function loadData() {
        setOpenLoad(true);
        const id = searchParms.get('id');
        if (id) {
            try {
                const data = { id_usuario: id };
                const response = await api.post(`/usuario`, data);
                if (response && response.status === 200 && response.data) {
                    if (response.data.error) AlertInfo({ icon: 'error', title: response.data.message });
                    else setDataResponse(response.data[0]);
                }
            } catch (error) {
                console.log(error);
                AlertInfo({ icon: "error", title: 'NÃO POSSIVEL BUSCAR DADOS' });
            }
        }
        setOpenLoad(false);
    }

    function deleteLogoUser() {
        AlertConfirm({ title: "Remover Logo do sistema?" }).then(async res => {
            if (res.isConfirmed) {
                try {
                    const filename = String(logo_user).replace(`${apiUrl}/imguploaded/`, "");
                    const response = await api.delete(`/removelogoescritorio/${filename}`);
                    if (response && response.status === 200 && response.data) {
                        if (response.data.success) {
                            AlertInfo({ icon: 'success', title: "Arquivo Removido" });
                            setLogoUser(null);
                        } else if (response.data.error) {
                            AlertInfo({ icon: 'error', title: response.data.message });
                        }
                    }
                } catch (error) {
                    console.log(error);
                    AlertInfo({ icon: 'error', title: "Falha na Conexão" });
                }
            }
        });
    }

    useEffect(() => {
        const fil = arrayUfNome.filter(uf => uf.value === sessao_oab_usuario_sigla);
        if (fil.length === 1) setSessaoOabUsuario(fil[0].label);
    }, [sessao_oab_usuario_sigla]);

    useEffect(() => {
        loadData();
        // eslint-disable-next-line
    }, []);

    return (
        <Templete menuActive="usuarios">
            <Grid container spacing={1}>
                {id_usuario && isPermite("2") && (
                    <>
                        <Grid item xs={false} sm={10}></Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                fullWidth
                                color="error"
                                onClick={handleDelete}
                            >
                                Deletar
                            </Button>
                        </Grid>
                    </>
                )}

                <Grid item xs={12}>
                    <Paper elevation={4} sx={{ overflow: "hidden" }}>
                        <Tabs
                            value={aba}
                            onChange={(_, v) => setAba(v)}
                            variant="fullWidth"
                            sx={{ borderBottom: "1px solid", borderColor: "divider" }}
                        >
                            <Tab icon={<PersonIcon />} iconPosition="start" label="Dados Usuário" sx={{ minHeight: 56 }} />
                            <Tab icon={<LockPersonIcon />} iconPosition="start" label="Permissões" sx={{ minHeight: 56 }} />
                        </Tabs>

                        {/* As abas ficam montadas (hidden) para preservar o estado do DropZone ao alternar */}
                        <Box hidden={aba !== 0} sx={{ p: { xs: 2, sm: 3 } }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        label="Nome usuario"
                                        autoFocus={id_usuario ? false : true}
                                        next="nome_abreviado_usuario"
                                        value={nome_usuario}
                                        setState={setNomeUsuario}
                                        isUpper={true}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        id="nome_abreviado_usuario"
                                        label="Abreviação"
                                        next="profissao_usuario"
                                        value={nome_abreviado_usuario}
                                        setState={setNomeAbreviadoUsuario}
                                        isUpper={true}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        id="profissao_usuario"
                                        label="Profissão"
                                        next="nacionalidade_usuario"
                                        value={profissao_usuario}
                                        setState={setProfissaoUsuario}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <SelectSimple
                                        id="nacionalidade_usuario"
                                        label="Nacionalidade"
                                        value={nacionalidade_usuario}
                                        setState={setNacionalidadeUsuario}
                                        options={nacionalidadeData}
                                        isNone
                                        next="estado_civil_usuario"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <SelectSimple
                                        id="estado_civil_usuario"
                                        label="Estado Civil"
                                        value={estado_civil_usuario}
                                        setState={setEstadoCivilUsuario}
                                        options={estadoCivilData}
                                        isNone
                                        next="rg_usuario"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        label="RG"
                                        id="rg_usuario"
                                        value={rg_usuario}
                                        setState={setRgUsuario}
                                        next="emissor_rg_usuario"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        label="Orgão Emissor"
                                        id="emissor_rg_usuario"
                                        value={emissor_rg_usuario}
                                        setState={setEmissorRgUsuario}
                                        next="telefone_usuario"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        label="Telefone"
                                        id="telefone_usuario"
                                        value={telefone_usuario}
                                        setState={setTelefoneUsuario}
                                        next="cpf_usuario"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        label="CPF"
                                        id="cpf_usuario"
                                        value={cpf_usuario}
                                        setState={setCpfUsuario}
                                        next="email_usuario"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <InputLabel
                                        label="Email"
                                        id="email_usuario"
                                        value={email_usuario}
                                        setState={setEmailUsuario}
                                        next="senha_usuario"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        label="Senha"
                                        type="password"
                                        id="senha_usuario"
                                        value={senha_usuario}
                                        setState={setSenhaUsuario}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        id="banco_advogado_rpv"
                                        type="text"
                                        label="Banco do Advogado"
                                        value={banco_advogado_rpv}
                                        setState={setBancoAdvRpv}
                                        next="numero_banco_rpv"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        id="numero_banco_rpv"
                                        type="text"
                                        label="Nº do Banco"
                                        value={numero_banco_rpv}
                                        setState={setNumeroBancoRpv}
                                        next="numero_agencia_rpv"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        id="numero_agencia_rpv"
                                        type="text"
                                        label="Nº da Agência"
                                        value={numero_agencia_rpv}
                                        setState={setNumeroAgenciaRpv}
                                        next="numero_conta_rpv"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputLabel
                                        id="numero_conta_rpv"
                                        type="text"
                                        label="Nº da Conta"
                                        value={numero_conta_rpv}
                                        setState={setNumeroContaRpv}
                                        next="chave_pix_usuario"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <InputLabel
                                        id="chave_pix_usuario"
                                        type="text"
                                        label="Chave PIX"
                                        value={chave_pix_usuario}
                                        setState={setChavePixUsuario}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={is_advogado}
                                                onChange={() => setIsAdvogado(!is_advogado)}
                                            />
                                        }
                                        label="ADVOGADO"
                                    />
                                </Grid>
                                {is_advogado && (
                                    <>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <InputLabel
                                                label="OAB"
                                                id="cod_oab"
                                                value={cod_oab}
                                                setState={setCodOAB}
                                                next="sessao_oab_usuario"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <SelectSimple
                                                label="Seção OAB"
                                                id="sessao_oab_usuario_sigla"
                                                value={sessao_oab_usuario_sigla}
                                                setState={setSessaoOabSigla}
                                                options={arrayUf}
                                            />
                                        </Grid>
                                        <Grid item xs={false} md={6} />

                                        {id_usuario && (
                                            <>
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <DropZoneFile
                                                        route="/saveLogoUsuario"
                                                        accept={[".png", ".jpg"]}
                                                        currentFile={logo_user}
                                                        handleDelete={deleteLogoUser}
                                                        aditional={[{ name: "id_usuario", value: id_usuario }]}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={3} sx={{ display: "flex", alignItems: "center" }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={is_logo_proprio}
                                                                onChange={() => setIsLogoProprio(!is_logo_proprio)}
                                                            />
                                                        }
                                                        label="Usar nome e logo nas petições"
                                                    />
                                                </Grid>
                                            </>
                                        )}
                                    </>
                                )}
                            </Grid>
                        </Box>

                        <Box hidden={aba !== 1} sx={{ p: { xs: 2, sm: 3 } }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Box sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 1 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={totalPermissoes > 0 && totalMarcadas === totalPermissoes}
                                                    indeterminate={totalMarcadas > 0 && totalMarcadas < totalPermissoes}
                                                    onChange={handleCheckTodas}
                                                />
                                            }
                                            label={`Marcar/desmarcar todas (${totalMarcadas}/${totalPermissoes})`}
                                        />
                                    </Box>
                                </Grid>
                                {permissoes.map(per => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={per.id}>
                                        <FormControl component="fieldset" variant="standard">
                                            <FormLabel component="legend">{per.label}</FormLabel>
                                            <FormGroup>
                                                {per.options.map(p => (
                                                    <FormControlLabel
                                                        key={p.value}
                                                        control={
                                                            <Checkbox
                                                                value={p.value}
                                                                checked={p.check}
                                                                onChange={() => handleCheck(per.id, p.value)}
                                                            />
                                                        }
                                                        label={p.label}
                                                    />
                                                ))}
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>

                <Grid item xs={false} sm={5}></Grid>
                <Grid item xs={12} sm={2}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="success"
                        onClick={handleSave}
                    >
                        Salvar
                    </Button>
                </Grid>
                <Grid item xs={false} sm={5}></Grid>

                <SimpleBackdrop open={openLoad} />
            </Grid>
        </Templete>
    );
}